document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Toast ---------- */
  function showToast(message) {
    var toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  /* ---------- Update cart bubble count ---------- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  /* ---------- AJAX Add to cart (product form + sticky bar) ---------- */
  document.querySelectorAll('form[data-atc-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var originalText = button ? button.textContent : '';
      if (button) {
        button.setAttribute('disabled', 'disabled');
        button.textContent = form.getAttribute('data-adding-text') || 'Ajout...';
      }
      var formData = new FormData(form);

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          updateCartCount();
          showToast(form.getAttribute('data-success-text') || 'Ajouté au panier ✓');
        })
        .catch(function () {
          showToast('Une erreur est survenue, réessayez.');
        })
        .finally(function () {
          if (button) {
            button.removeAttribute('disabled');
            button.textContent = originalText;
          }
        });
    });
  });

  /* ---------- Quantity selectors ---------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Sticky add-to-cart bar on product pages ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainAtcButton = document.querySelector('[data-main-atc-button]');
  if (stickyBar && mainAtcButton) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainAtcButton);
  }

  /* ---------- Product gallery (thumbnails + arrows) ---------- */
  var galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
  var galleryMainImg = document.querySelector('[data-gallery-main-img]');
  var galleryPrevBtn = document.querySelector('[data-gallery-prev]');
  var galleryNextBtn = document.querySelector('[data-gallery-next]');
  var galleryIndex = 0;

  function setGalleryIndex(index) {
    if (!galleryThumbs.length || !galleryMainImg) return;
    galleryIndex = (index + galleryThumbs.length) % galleryThumbs.length;
    var thumb = galleryThumbs[galleryIndex];
    var newSrc = thumb.getAttribute('data-full-src');
    if (newSrc) galleryMainImg.src = newSrc;
    galleryThumbs.forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  galleryThumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { setGalleryIndex(i); });
  });
  if (galleryPrevBtn) galleryPrevBtn.addEventListener('click', function () { setGalleryIndex(galleryIndex - 1); });
  if (galleryNextBtn) galleryNextBtn.addEventListener('click', function () { setGalleryIndex(galleryIndex + 1); });

  /* ---------- Cart quantity update on cart page ---------- */
  document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: input.value })
      }).then(function () { window.location.reload(); });
    });
  });

  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var line = btn.getAttribute('data-line');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Mobile menu ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavOverlay = document.querySelector('[data-mobile-nav-overlay]');
  var mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenuClose = document.querySelector('[data-mobile-menu-close]');

  function openMobileNav() {
    if (!mobileNav || !mobileNavOverlay) return;
    mobileNav.classList.add('is-open');
    mobileNavOverlay.classList.add('is-open');
    if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav || !mobileNavOverlay) return;
    mobileNav.classList.remove('is-open');
    mobileNavOverlay.classList.remove('is-open');
    if (mobileMenuToggle) mobileMenuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openMobileNav);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMobileNav);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobileNav();
  });

  /* ---------- Before/After slider ---------- */
  document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
    var frame = slider.querySelector('.ba-slider__frame');
    var afterWrap = slider.querySelector('[data-ba-after-wrap]');
    var handle = slider.querySelector('[data-ba-handle]');
    var afterImg = slider.querySelector('.ba-slider__after-wrap .ba-slider__img');
    var input = slider.querySelector('[data-ba-input]');

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      afterWrap.style.width = percent + '%';
      handle.style.left = percent + '%';
      if (afterImg && frame) {
        afterImg.style.width = frame.offsetWidth + 'px';
      }
      if (input) input.value = percent;
    }

    function percentFromEvent(clientX) {
      var rect = frame.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    var dragging = false;
    frame.addEventListener('pointerdown', function (e) {
      dragging = true;
      setPosition(percentFromEvent(e.clientX));
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPosition(percentFromEvent(e.clientX));
    });
    window.addEventListener('pointerup', function () { dragging = false; });

    if (input) {
      input.addEventListener('input', function () { setPosition(parseFloat(input.value)); });
    }

    window.addEventListener('resize', function () { setPosition(parseFloat(input ? input.value : 50)); });
    setPosition(50);
  });

});
